// extracted by mini-css-extract-plugin
module.exports = {"container":"container--f7978"};